import React, { useMemo, useState, useEffect } from "react";
import "./components/Global/index.scss";
import HeaderMultiMonitor from "./components/HeaderMultiMonitor";
import Header from "./components/Header";
import { Routes, Route } from "react-router-dom";
import { MainPage } from "./pages/main";
import { Monitor } from "./pages/monitor";
import { MonitorMulti } from "./pages/monitor-multi";
import { NotFound } from "./pages/NotFound";
import CentrifugeClient from "./utils/centrifugeClient";
import axios from "axios";
import { useLocation } from "react-router";
import QueueClass from "./utils/Queue";

const newQueue = new QueueClass();
const checkPlay = { val: false };

function App() {
	const location = useLocation();
	const isMonitorMulti = location.pathname.includes("/monitor-multi/");
	const [all_queue, setAllQueue] = useState();
	const [processed, setProcessed] = useState();
	const [dateTime, setDateTime] = useState(new Date());
	const [visibleCoupon, setVisibleCoupon] = useState(false);
	const [audio, setAudio] = useState(new Audio());

	const apiUrl = process.env.REACT_APP_SCHEMA + (
		process.env.REACT_APP_PORT
			? process.env.REACT_APP_DOMAIN + ':' + process.env.REACT_APP_PORT
			: process.env.REACT_APP_DOMAIN
	);

	// Initialize centrifuge client
	const centrifugeClient = useMemo(() => new CentrifugeClient(), []);

	useEffect(() => {
		// Connect to centrifuge
		centrifugeClient.connect().then(() => {
			// Subscribe to tickets-chat channel
			centrifugeClient.subscribe('tickets-chat', (data) => {
				const registryIdFromPath = location.pathname.replace('/monitor/', '')
					.replace('/terminal/', '')
					.replace('/monitor-multi/', '');

				if (data.registry_id === registryIdFromPath) {
					if (data.ticket_process) {
						if (data.ticket_process.ticket) {
							let getInfo = {
								ticket: data.ticket_process.ticket,
								window: data.ticket_process.window,
							};
							newQueue.enqueue(getInfo);
						}

						setAllQueue(data.all_tickets ?? data.all_queue);
						setProcessed(data.processed);
					}
				}
			});

			// Subscribe to reload-monitor channel
			centrifugeClient.subscribe('reload-monitor', (data) => {
				const registryIdFromPath = location.pathname.replace('/monitor/', '')
					.replace('/terminal/', '')
					.replace('/monitor-multi/', '');

				if (data.registry_id === registryIdFromPath) {
					setInterval(() => {
						if (newQueue.isEmpty() && checkPlay.val === false && visibleCoupon === false && audio.paused) {
							console.log('reloading...');
							document.location.reload(true)
						}
					}, 1000);
				}
			});

			// Subscribe to datetime channel
			centrifugeClient.subscribe('datetime', (data) => {
				setDateTime(new Date(data.datetime))
			});

			// Connect monitor to backend
			const connectMonitor = () => {
				if (location.pathname.match('monitor')) {
					console.log('connecting monitor...');
					let registry_id = location.pathname;
					registry_id = registry_id.replace('/monitor/', '');
					registry_id = registry_id.replace('/terminal/', '');
					registry_id = registry_id.replace("/monitor-multi/", "");

					axios.get(apiUrl + "/api/public/v1.0/connect-new-monitor?registry_id="
						+ registry_id
						+ '&token='
						+ process.env.REACT_APP_API_PUBLIC_TOKEN)
						.then(() => {
							console.log('monitor connected');
						})
						.catch((error) => {
							console.error('Failed to connect monitor:', error);
						});
				}
			};

			// Wait for connection then connect monitor
			const checkConnectionInterval = setInterval(() => {
				if (centrifugeClient.connected) {
					connectMonitor();
					clearInterval(checkConnectionInterval);
				}
			}, 1000);
		});

		// Cleanup: unsubscribe and reconnect periodically (30 minutes)
		const unsubscribeInterval = setInterval(() => {
			console.log('Reconnecting centrifuge...');

			centrifugeClient.unsubscribe('tickets-chat');
			centrifugeClient.unsubscribe('reload-monitor');
			centrifugeClient.unsubscribe('datetime');
			centrifugeClient.disconnect();

			// Clear caches
			if ('caches' in window) {
				caches.keys().then(cacheNames => {
					cacheNames.forEach(cacheName => {
						caches.delete(cacheName);
					});
					console.log('Cache cleared');
				});
			}
			localStorage.clear();
			sessionStorage.clear();

			// Reconnect
			centrifugeClient.connect().then(() => {
				centrifugeClient.subscribe('tickets-chat', (data) => {
					const registryIdFromPath = location.pathname.replace('/monitor/', '')
						.replace('/terminal/', '')
						.replace('/monitor-multi/', '');

					if (data.registry_id === registryIdFromPath) {
						if (data.ticket_process) {
							if (data.ticket_process.ticket) {
								let getInfo = {
									ticket: data.ticket_process.ticket,
									window: data.ticket_process.window,
								};
								newQueue.enqueue(getInfo);
							}

							setAllQueue(data.all_tickets ?? data.all_queue);
							setProcessed(data.processed);
						}
					}
				});

				centrifugeClient.subscribe('reload-monitor', (data) => {
					const registryIdFromPath = location.pathname.replace('/monitor/', '')
						.replace('/terminal/', '')
						.replace('/monitor-multi/', '');

					if (data.registry_id === registryIdFromPath) {
						setInterval(() => {
							if (newQueue.isEmpty() && checkPlay.val === false && visibleCoupon === false && audio.paused) {
								console.log('reloading...');
								document.location.reload(true)
							}
						}, 1000);
					}
				});

				centrifugeClient.subscribe('datetime', (data) => {
					setDateTime(new Date(data.datetime))
				});
			});
		}, 30 * 60 * 1000); // 30 minutes

		return () => {
			clearInterval(unsubscribeInterval);
			centrifugeClient.disconnect();
		};
	}, [location.pathname, centrifugeClient, apiUrl, audio, visibleCoupon]);

	return (
		<>
			{isMonitorMulti ? <HeaderMultiMonitor dateTime={dateTime} /> : <Header dateTime={dateTime} />}

			<Routes>
				<Route path='/terminal/:id' element={<MainPage />} />
				<Route path='/monitor-multi/:id' element={<MonitorMulti
					newQueue={newQueue}
					checkPlay={checkPlay}
					processed={processed}
					all_queue={all_queue}
					visibleCoupon={visibleCoupon}
					setVisibleCoupon={setVisibleCoupon}
					audio={audio}
					setAudio={setAudio}
				/>} />
				<Route path='/monitor/:id' element={<Monitor
					newQueue={newQueue}
					checkPlay={checkPlay}
					processed={processed}
					all_queue={all_queue}
					visibleCoupon={visibleCoupon}
					setVisibleCoupon={setVisibleCoupon}
					audio={audio}
					setAudio={setAudio}
				/>} />
				<Route path='*' element={<NotFound />} />
			</Routes>
		</>
	);
}

export default App;
